import ListingPage from './ListingPage';
export default ListingPage;
